module.exports = __webpack_public_path__ + "assets/img/star_sentence_un7.47a7857c.png";